import { makeStyles } from '@material-ui/core/styles';

export const useLayoutStyles = makeStyles(theme => ({
  content: {
    width: '100%',
    maxWidth: theme.limits.max,
    margin: '0 auto',
    minHeight: 'calc(100vh - 320px)',
    backgroundColor: theme.palette.yellow
  }
}));
